export default __webpack_public_path__ + "static/media/milestone 900.d232bb57.svg";